import React, { Suspense, lazy } from 'react'

import SplashScreen from '@/components/SplashScreen'
import { Box, Typography } from '@material-ui/core'

const ProductsRanking = lazy(() => import('./RankingProdutos'))
const ReserveOrders = lazy(() => import('./PedidosReservados'))
const PaymentSlips = lazy(() => import('./Duplicatas'))
const Comissions = lazy(() => import('./Comissoes'))
const BilledOrders = lazy(() => import('./PedidosFaturados'))
const Inventory = lazy(() => import('./Estoque'))

export default function DynamicReportRender({ reportId }) {
  const administrativeReportsMapping = {
    1: ProductsRanking,
    2: ReserveOrders,
    3: PaymentSlips,
    4: BilledOrders,
    5: Comissions,
    6: Inventory,
  }

  const CurrentReportComponent = administrativeReportsMapping[reportId]

  return (
    <Suspense fallback={<SplashScreen loaderSize={8} />}>
      {CurrentReportComponent ? (
        <CurrentReportComponent />
      ) : (
        <Box
          minHeight={760}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography variant="h5" color="textSecondary">
            Selecione a consulta no menu acima.
          </Typography>
        </Box>
      )}
    </Suspense>
  )
}
